<template>
    <div>
        <div
            v-if="!method.name.includes('Abonnement') && !method.name.includes('Cure') && !method.name.includes('cadeau')"
            class="form-check form-block"
        >
            <slot name="checkbox"></slot>
            <label class="form-check-label" :for="'checkbox_' + method.name" :style="'border: 2px solid ' + method.color ">
                <span class="d-flex align-items-center">
                    <span class="ms-2 w-100">
                        <span class="fw-bold">{{ method.name }}</span>
                    </span>
                    <span >
                        <slot name="input"></slot>
                    </span>
                </span>
            </label>
        </div>
        <div v-else>
            <input type="hidden" :name="'payments[' + method.name + ']'" v-model="method.value" />
        </div>
    </div>
</template>

<script>
export default {
    props: ['method', 'remainPrice'],
}
</script>
